import { useEffect, useState, useMemo } from "react";
import { Outlet, NavLink, Link, useLocation } from "react-router-dom";
import { AccessToken, Claim } from "../../api";

import github from "../../assets/github.svg";

import styles from "./Layout.module.css";

const Layout = () => {

    const location = useLocation();

    const [imageSrc, setImageSrc] = useState("/ir.gif");
    const [homeUrl, setHomeUrl] = useState("https://www.ygkenpo.jp/index.html");
    const [organiStr, setOrganiStr] = useState("ＹＧ健康保険組合");

//    const [loginUser, setLoginUser] = useState<string>("");
    const [loginUser, setLoginUser] = useState<string>("anonymous");

    const [menuOpen, setMenuOpen] = useState(false);

//    const getLoginUserName = async () => {
//        // ログイン処理をスキップして、一律で anonymous を設定する
//        setLoginUser("anonymous");
//    };

//    const getLoginUserName = async () => {
//        const loginUser: string = "";

//        try {
//            const result = await fetch("/.auth/me");

//            // 正常にデータが取得できなかった（404や500など）場合は、即座にエラー扱いにしてcatchへ飛ばす
//            if (!result.ok) {
//                throw new Error("Auth endpoint not found or error occurred");
//            }

//            const response: AccessToken[] = await result.json();
//            const loginUserClaim = response[0].user_claims.find((claim: Claim) => claim.typ === "preferred_username");
//            if (loginUserClaim) setLoginUser(loginUserClaim.val);
//            else setLoginUser(response[0].user_id);
//        } catch (e) {
//        setLoginUser("anonymous");
//            setLoginUser("anonymous");
//        }
//    };

    useEffect(() => {
//        getLoginUserName();

        const params = new URLSearchParams(location.search);
        const kname = params.get("kname");

        if (kname === "共同印刷株式会社") {
            setImageSrc("/TOMOWeL.jpg");
	    setHomeUrl("https://www.kyodoprinting.co.jp/");
            setOrganiStr("共同印刷株式会社");
//        } else {
//            setImageSrc("/ir.gif");
        }

    }, []);


    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className={styles.headerContainer}>
                    <Link to={homeUrl} className={styles.headerTitleContainer}>
                        {/* <h3 className={styles.headerTitleLeft}>企業内向けChatと社内文書検索</h3> */}
                        <img src={imageSrc} alt={organiStr} className={styles.headerIcon} />
                    </Link>

                    <button
                        className={styles.hamburger}
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>

                    <nav className={menuOpen ? styles.navOpen : styles.nav}>
                        <ul className={styles.headerNav}>
                            <li><a href="https://www.ygkenpo.jp/member/outline/index.html">健保のしくみ</a></li>
                            <li><a href="https://www.ygkenpo.jp/member/application/index.html">健保の手続き</a></li>
                            <li><a href="https://www.ygkenpo.jp/member/health/checkup_a.html">健康づくり</a></li>
                            <li><a href="https://www.ygkenpo.jp/member/application/form.html">申請書一覧</a></li>
                            <li><a href="https://www.ygkenpo.jp/asp/faq/faq.asp">よくある質問</a></li>
                            <li><a href="https://www.ygkenpo.jp/member/info/access.html">組合案内・アクセス</a></li>
                        </ul>
                    </nav>
		    {/*
                    <nav>
                        <ul className={styles.headerNavList}>
                            <li>
                                <NavLink to="/" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>
                                    企業内向けChat
                                </NavLink>
                            </li>
                            <li className={styles.headerNavLeftMargin}>
                                <NavLink to="/docsearch" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>
                                    社内文書検索
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                    <h3 className={styles.headerTitleRight}>{loginUser}</h3>
		    */}
                </div>
            </header>

            <Outlet />

            <footer className={styles.footer}>
                <div>
                    <ul className={styles.footerNav}>
                        <li><a href="https://www.ygkenpo.jp/member/info/intro.html">組合案内</a></li>
                        <li><a href="https://www.ygkenpo.jp/member/info/access.html">アクセス</a></li>
                        <li><a href="https://www.ygkenpo.jp/member/info/policy.html">個人情報保護について</a></li>
                        <li><a href="https://www.ygkenpo.jp/member/info/link.html">リンク</a></li>
                        <li><a href="https://www.ygkenpo.jp/member/info/sitemap.html">サイトマップ</a></li>
                    </ul>
		    <br />
                    <p><small>Copyright (C) 2018 YG Health Insurance Society All Rights Reserved.</small></p>
                </div>
            </footer>
        </div>
    );
};

export default Layout;
